import server from '@/request/encryptRequest';

// 查询分页列表
export const getLogLists = (data) => {
  return server.post('/xiaozi-saas/wireless/dynamicInformation/pageList', data);
};
